export default function typeToFa(type: string): string {
  switch (type) {
    case 'external':
      return 'نشانی خارجی';
    case 'internal':
      return 'نشانی داخلی';
    case 'image':
      return 'تصویر';
    case 'css':
      return 'فایل CSS';
    case 'js':
      return 'فایل JS';
    default:
      return 'ناشناخته';
  }
}
